import { httpClient } from '../lib/httpClient';
import type {
  CountriesResponse,
  CountriesQueryParams,
} from '../interfaces/apiInterfaces/countries';

export async function fetchCountries(
  params?: CountriesQueryParams
): Promise<CountriesResponse> {
  const response = await httpClient.get<CountriesResponse>('/v1/countries', {
    params,
  });
  return response.data;
}
